module.exports = __webpack_public_path__ + "img/隐式安装读卡器 (1).a57190d4.jpg";